import { MiscLedgerPage } from './_shared/MiscLedgerPage';
import { MiscLedgerDirection } from '@/services/api/frontdeskOps.types';

export function MiscExpensePage() {
  return <MiscLedgerPage direction={MiscLedgerDirection.EXPENSE} />;
}
